import _slicedToArray from "/Users/jfriend/code/scaletoy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/Users/jfriend/code/scaletoy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { deprecate } from '@tonaljs/core';
import { chromaToIntervals, EmptyPcset } from '@tonaljs/pcset';
var DATA = [[0, 2773, 0, "ionian", "", "Maj7", "major"], [1, 2902, 2, "dorian", "m", "m7"], [2, 3418, 4, "phrygian", "m", "m7"], [3, 2741, -1, "lydian", "", "Maj7"], [4, 2774, 1, "mixolydian", "", "7"], [5, 2906, 3, "aeolian", "m", "m7", "minor"], [6, 3434, 5, "locrian", "dim", "m7b5"]];

var NoMode = _objectSpread({}, EmptyPcset, {
  name: "",
  alt: 0,
  modeNum: NaN,
  triad: "",
  seventh: "",
  aliases: []
});

var modes = DATA.map(toMode);
var index = {};
modes.forEach(function (mode) {
  index[mode.name] = mode;
  mode.aliases.forEach(function (alias) {
    index[alias] = mode;
  });
});
/**
 * Get a Mode by it's name
 *
 * @example
 * get('dorian')
 * // =>
 * // {
 * //   intervals: [ '1P', '2M', '3m', '4P', '5P', '6M', '7m' ],
 * //   modeNum: 1,
 * //   chroma: '101101010110',
 * //   normalized: '101101010110',
 * //   name: 'dorian',
 * //   setNum: 2902,
 * //   alt: 2,
 * //   triad: 'm',
 * //   seventh: 'm7',
 * //   aliases: []
 * // }
 */

function get(name) {
  return typeof name === "string" ? index[name.toLowerCase()] || NoMode : name && name.name ? get(name.name) : NoMode;
}

var mode = deprecate("Mode.mode", "Mode.get", get);
/**
 * Get a list of all modes
 */

function all() {
  return modes.slice();
}

var entries = deprecate("Mode.mode", "Mode.all", all);
/**
 * Get a list of all mode names
 */

function names() {
  return modes.map(function (mode) {
    return mode.name;
  });
}

function toMode(mode) {
  var _mode = _slicedToArray(mode, 7),
      modeNum = _mode[0],
      setNum = _mode[1],
      alt = _mode[2],
      name = _mode[3],
      triad = _mode[4],
      seventh = _mode[5],
      alias = _mode[6];

  var aliases = alias ? [alias] : [];
  var chroma = Number(setNum).toString(2);
  var intervals = chromaToIntervals(chroma);
  return {
    empty: false,
    intervals: intervals,
    modeNum: modeNum,
    chroma: chroma,
    normalized: chroma,
    name: name,
    setNum: setNum,
    alt: alt,
    triad: triad,
    seventh: seventh,
    aliases: aliases
  };
}

var index$1 = {
  get: get,
  names: names,
  all: all,
  // deprecated
  entries: entries,
  mode: mode
};
export default index$1;
export { all, entries, get, mode, names };